<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

const isLoggedIn = computed(() => {
	return authStore.isLoggedIn;
});

const labels = ref(window.portal.labels);

const isLoggingOut = ref(false);

const logout = async () => {
	if (isLoggingOut.value) return;

	isLoggingOut.value = true;

	try {
		//Send the request for logging out
		await axios.post(window.portal.logout_url);
	} catch (error) {
		//Nothing really needs to be handled
	} finally {
		//Clear the stored data
		authStore.logout();

		//Refresh the page?

		//Done
		isLoggingOut.value = false;
	}
}
</script>

<template>
	<a v-if="isLoggedIn" @click.prevent="logout" v-html="labels.sign_out"></a>
	<a v-else href="#sign-in" v-html="labels.sign_in"></a>
</template>
